import axios from 'axios'
import * as streamingAvailability from 'streaming-availability'

const tmdbUrl: string = import.meta.env.VITE_TMDB_API_URL
const apiToken: string = import.meta.env.VITE_API_TOKEN


// This makes the call to ur TMDB service
const api = () =>
  axios.create({
    baseURL: tmdbUrl,
    headers: {
      'Content-Type': 'application/json',
      Authorization: apiToken, // Authorization header
    },
  })

export default api

/**
 * In dev:
 *   VITE_BACKEND_BASE can be empty -> use Vite proxy to localhost:4000
 * In prod:
 *   set VITE_BACKEND_BASE=https://bfemicroservice-production.up.railway.app
 */
const BACKEND_BASE =
  (import.meta.env.VITE_BACKEND_BASE as string | undefined)?.replace(/\/$/, '') ||
  (import.meta.env.DEV ? '' : 'https://bfemicroservice-production.up.railway.app');

// Plain backend client (for your own /api routes)
export const backend = axios.create({
  baseURL: BACKEND_BASE || '', // '' = same-origin (use Vite proxy in dev)
  timeout: 15000,
});

// Proxy client for TMDB (your server exposes /api/tmdb/*)
export const tmdb = axios.create({
  baseURL: `${BACKEND_BASE || ''}/api/tmdb`,
  timeout: 15000,
});


// Streaming-Availability client configuration
const client = new streamingAvailability.Client(
  new streamingAvailability.Configuration({
    apiKey: import.meta.env.VITE_RAPID_API_KEY,
  })
);

// Function to fetch streaming service data dynamically
export const getStreamingServicesById = async (id: string, type: 'movie' | 'tv' = 'movie') => {
  try {
    const formattedId = `${type}/${id}`;

    const show = await client.showsApi.getShow({ id: formattedId });

    return show; // ← This is your full show object (with imdbId, title, etc.)
  } catch (error) {
    console.error('Error fetching streaming services:', error);
    throw error;
  }
};

export { client };


// Get logo for our hero section

export async function fetchMovieLogo(
  tmdbId: number,
  size: "w300" | "w500" | "w780" | "original" = "w780",
  opts?: { lang?: string; strict?: boolean; minWidth?: number; preferSvg?: boolean }
) {
  const { lang = "en", strict = false, minWidth = 1000, preferSvg = true } = opts ?? {};
  const { data } = await tmdb.get("/logo", { params: { tmdbId, size, lang, strict, minWidth, preferSvg } });
  return (data?.logoUrl as string) || null;
}

